import {
  Badge,
  Box,
  Card,
  Center,
  Divider,
  Group,
  Modal,
  ScrollArea,
  Skeleton,
  Text,
  Title,
} from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { IconCamera } from "@tabler/icons-react";
import { logger } from "utils/logger";
import { createStyles } from "@mantine/emotion";
import { getStyle } from "services/styleService";
import { useDispatch } from "react-redux";

import Moment from "react-moment";

// import StyleAssetViewer from "../style/StyleAssetViewer";
import { ERROR_MESSAGES, ERROR_TYPES } from "utils/constants";
import { PrimaryBadge } from "core/components/badge/PrimaryBadge";
import { MapDisplay } from "core/components/mapDisplay/MapDisplay";
import { getClientLabel, getImageFile, getStatusColor } from "utils/helper";
import SingleLayout from "core/components/approval/SingleLayout";
// import AssetViewer from "core/components/approval/AssetViewer";
import { MetaLabel } from "core/components/metaLabel/MetaLabel";
import { selectStyle, setError } from "modules/Wip/wipSlice";
import StyleInfoSections from "core/components/styleInfoSections/StyleInfoSections";
import ImagePreview from "core/components/imagePreview/ImagePreview";
import { EmptyState } from "core/components/emptyState/EmptyState";
import StyleAssetViewer from "core/components/styleInfoPanel/StyleAssetViewer";
import { DateDisplay } from "core/components/index";

const useStyles = createStyles((theme, _, u) => ({
  container: {
    padding: 0,
    height: "100%",
    borderLeftWidth: 0,
    borderLeftStyle: "solid",
    // paddingTop: 26,
    borderColor: theme.colors.dark[4],
    [u.light]: {
      borderColor: theme.colors.gray[3],
    },
    ".mantine-Accordion-content": {
      paddingBottom: 0,
    },
    ".mantine-Accordion-control": {
      borderTopWidth: 1,
      borderTopStyle: "solid",
      borderColor: theme.colors.dark[4],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
    ".mantine-Stack-root": {
      // gap: 0,
    },
    ".capture-selected > div > div:first-of-type": {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.colors.brand[1],
      [u.light]: {
        borderColor: theme.colors.gray[3],
      },
    },
  },
  badgeIndex: {
    position: "absolute",
    left: 0,
    top: 0,
  },
  imageGradient: {
    background: `linear-gradient(to top, #242424, transparent)`,
    height: 200,
    width: "100%",
    position: "absolute",
    bottom: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
    [u.light]: {
      background: `linear-gradient(to top, #fff, transparent)`,
    },
  },
  barcodeSection: {
    backgroundColor:
      theme.colorScheme === "dark" ? theme.colors.dark[9] : theme.white,
  },
}));

const InfoPanel = ({ selectedItem, opened, doFetch = true, user }) => {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("info");
  const [session, setSelectedSession] = useState(null);
  const [talent, setTalent] = useState([]);
  const dispatch = useDispatch();
  const hasFetched = useRef(false);

  const [selectedAsset, setSelectedAsset] = useState(null);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [scanImage, setScanImage] = useState(null);
  const lastFetchedStyleNumber = useRef(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    logger.log(selectedItem);

    if (selectedItem && selectedItem.scanUrl) {
      getImageFile(selectedItem.scanUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          logger.log(blob);
          setScanImage({ name: selectedItem.id, preview: url });
        });
    }

    const getStyleInfo = async (id) => {
      try {
        setLoading(true);
        const data = await getStyle(id);

        if (data) {
          logger.log(data);
          const { masters, sessions, seasons, assets, ...rest } = data;
          dispatch(
            selectStyle({ ...selectedItem, masters, sessions, seasons, assets })
          );
        }
      } catch (e) {
        dispatch(
          setError({
            type: ERROR_TYPES.NOT_FOUND,
            message: ERROR_MESSAGES[ERROR_TYPES.NOT_FOUND],
          })
        );
      } finally {
        setLoading(false);
      }
    };

    if (selectedItem && selectedItem.styleNumber) {
      const styleNumber = selectedItem.styleNumber;
      const isDifferentStyle = lastFetchedStyleNumber.current !== styleNumber;

      // Reset fetch flag if it's a different style
      if (isDifferentStyle) {
        hasFetched.current = false;
      }

      if (doFetch && !hasFetched.current && opened) {
        getStyleInfo(selectedItem.styleNumber);
        hasFetched.current = true;
        lastFetchedStyleNumber.current = styleNumber;
      } else if (doFetch && !opened) {
        hasFetched.current = true;
        lastFetchedStyleNumber.current = null;
      }
    }
  }, [selectedItem, opened]);

  const zoomImage = (data) => {
    logger.log(data);
    setSelectedAsset(data);
    setImageModalOpen(true);
  };

  const { theme } = useStyles();

  return (
    <Box className={`${classes.container} info-panel unhightable`}>
      <div style={{ width: "100%", height: "calc(100% - 46px)" }}>
        <ScrollArea sx={{ height: "100%" }}>
          {selectedItem ? (
            <Card pt="lg" style={{ background: "none" }}>
              {selectedItem.scanUrl ? (
                <Card.Section
                  style={{
                    position: "relative",
                    height: 400,
                    backgroundColor:
                      theme.colorScheme === "dark"
                        ? theme.colors.dark[9]
                        : theme.white,
                  }}
                >
                  {scanImage && (
                    <SingleLayout
                      toolbarStyle={{
                        position: "absolute",
                        top: 0,
                        left: -15,
                        zIndex: 1000,
                        border: 0,
                      }}
                      image={scanImage}
                      showSettings={false}
                      showToolbar={true}
                      settings={{ layoutType: "" }}
                    />
                  )}
                  {/* <ResolverImage
                    className={classes.image}
                    fit="cover"
                    src={
                      selectedItem && selectedItem.scanUrl
                        ? selectedItem.scanUrl
                        : ""
                    }
                    alt={selectedItem?.name}
                    height={300}
                  /> */}
                  {/* {selectedItem &&
                selectedItem.assets &&
                selectedItem.assets.length ? (
                  <AnimatePresence mode="wait">
                    <motion.img
                      key={currentIndex}
                      src={selectedItem?.assets[currentIndex].preview}
                      alt={`Slide ${currentIndex}`}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 1 }}
                      transition={{ duration: 5 }}
                      style={{
                        width: "100%",
                        height: 300,
                        objectFit: "cover",
                        position: "relative",
                      }}
                    />
                  </AnimatePresence>
                ) : null} */}

                  {/* <div className={classes.imageGradient}></div> */}
                </Card.Section>
              ) : (
                <Card.Section
                  className={classes.barcodeSection}
                  sx={(theme) => ({
                    backgroundColor:
                      theme.colorScheme === "dark"
                        ? theme.colors.dark[9]
                        : theme.white,
                  })}
                >
                  <BarcodeImage />
                </Card.Section>
              )}

              <Group
                style={{ flexWrap: "nowrap" }}
                justify="space-between"
                align="flex-start"
              >
                <Title
                  className="main-content-heading"
                  order={5}
                  // w={"100%"}
                  display={"inline-block"}
                  mt={"lg"}
                  textWrap={true}
                  style={{ flexShrink: 1 }}
                >
                  {selectedItem?.name}
                </Title>

                <Badge
                  variant="light"
                  mt={"lg"}
                  color={getStatusColor(selectedItem.status)}
                  style={{
                    flexShrink: 0,
                  }}
                >
                  {selectedItem.status}
                </Badge>

                {/* <Tooltip color="dark" label="Navigate to Style">
                    <ActionIcon variant="default" mt={"lg"}>
                      <IconArrowUpRight
                        size={AppConstants.ICON_SIZE}
                        stroke={AppConstants.ICON_STROKE_WIDTH}
                      />
                    </ActionIcon>
                  </Tooltip> */}
              </Group>

              <Box>
                <Group my="md">
                  <MetaLabel>Style Number</MetaLabel>
                  <div>
                    <Text size="sm">{selectedItem?.styleNumber}</Text>
                  </div>
                </Group>
                <Group my="md">
                  <MetaLabel>Session</MetaLabel>
                  {selectedItem?.sessionCodes &&
                  selectedItem?.sessionCodes.length ? (
                    <div>
                      {selectedItem?.sessionCodes.map((val) => (
                        <Text size="sm">{val}</Text>
                      ))}
                    </div>
                  ) : (
                    <div>
                      <Text c={"dimmed"} size="sm">
                        No sessions
                      </Text>
                    </div>
                  )}
                </Group>
                <Group my="md">
                  <MetaLabel>Department</MetaLabel>
                  <div>
                    <Text size="sm">{selectedItem.dept}</Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel>{getClientLabel(user.clientCode, 'otbDate')}</MetaLabel>
                  <div>
                    <Text
                      size="sm"
                      c={
                        selectedItem.otbDate && selectedItem.otbDate.length
                          ? "inherit"
                          : "dimmed"
                      }
                    >
                      {selectedItem.otbDate && selectedItem.otbDate.length
                        ? <DateDisplay
                          value={selectedItem.otbDate}
                          parse="YYYY-MM-DD-hh-mm-ss"
                          format="DD/MM/YYYY"
                          trim
                        />
                          
                        : "-"}
                    </Text>
                  </div>
                </Group>

                <Group my="md">
                  <MetaLabel>Shoot Date</MetaLabel>
                  <div>
                    <Text
                      size="sm"
                      c={
                        selectedItem.shootDate && selectedItem.shootDate.length
                          ? "inherit"
                          : "dimmed"
                      }
                    >
                      {selectedItem.shootDate && selectedItem.shootDate.length
                        ? // <Moment
                          //   date={selectedItem.shootDate}
                          //   parse="YYYY-MM-DD-hh-mm-ss"
                          //   format="DD/MM/YYYY"
                          //   trim
                          // />
                          selectedItem.shootDate
                        : "-"}
                    </Text>
                  </div>
                </Group>

                {/* <Group my="md">
                  <Text size="sm" style={{ width: "30%" }} fw={500}>
                    Status
                  </Text>
                  <div>
                    
                  </div>
                </Group> */}
              </Box>

              {selectedItem.scanLocation &&
              selectedItem.scanLat &&
              selectedItem.scanLon ? (
                <>
                  <Divider />

                  <Box mt={"xl"}>
                    <Title className="main-content-heading" order={6}>
                      Latest Scan Details
                    </Title>
                    <Group my="md">
                      <div style={{ flexGrow: 1 }}>
                        {/* <Text mb={'sm'} size={'sm'}>{scan?.location}</Text>                                     */}
                        <MapDisplay
                          created={selectedItem.scanned}
                          lat={selectedItem.scanLat}
                          lng={selectedItem.scanLon}
                          location={selectedItem.scanLocation}
                          width={"100%"}
                          height={300}
                          allowZoom={false}
                        />
                      </div>
                    </Group>
                    {/* <Group mb="lg">
                      {selectedItem?.assets?.length ? (
                        <PrimaryBadge>
                          {selectedItem?.assets?.length}
                        </PrimaryBadge>
                      ) : null}
                    </Group> */}

                    <Group my="md">
                      <MetaLabel>Scanned Date</MetaLabel>
                      <div>
                        <Text size="sm">
                          {selectedItem.scanned &&
                          selectedItem.scanned.length ? (
                            <Moment
                              date={selectedItem.scanned}
                              parse="YYYY-MM-DD-hh-mm-ss"
                              format="DD/MM/YYYY"
                              trim
                            />
                          ) : (
                            ""
                          )}
                        </Text>
                      </div>
                    </Group>
                    <Group my="md">
                      <MetaLabel>Location</MetaLabel>
                      <div>
                        <Text size="sm">{selectedItem.scanLocation}</Text>
                      </div>
                    </Group>

                    {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
                  </Box>
                </>
              ) : (
                <></>
              )}

              <StyleInfoSections
                selectedItem={selectedItem}
                user={user}
                storageKey="op-wip-drawer"
                loading={loading}
              />

              <Divider />
              <Box mt={"md"}>
                <Group mb="lg">
                  <Title className="main-content-heading" order={6}>
                    Assets
                  </Title>
                  {selectedItem?.assets?.length ? (
                    <PrimaryBadge>{selectedItem?.assets?.length}</PrimaryBadge>
                  ) : null}
                </Group>
                <Group
                  gap={"md"}
                  wrap="wrap"
                  justify="start"
                  style={{ display: "flex" }}
                >
                  {loading
                    ? // Show skeletons when loading
                      [...Array(3)].map((_, idx) => (
                        <Skeleton
                          key={`skeleton-${idx}`}
                          height={100}
                          width={80}
                          radius={8}
                        />
                      ))
                    : // Show actual assets when not loading
                      selectedItem?.assets?.map((val, idx) => {
                        // var imageURL = val && val.preview ? val.preview : "";
                        return (
                          <div
                            key={idx}
                            style={{
                              height: "100%",
                              width: 80,
                              position: "relative",
                              borderRadius: 8,
                              overflow: "hidden",
                            }}
                          >
                            {val ? (
                              <ImagePreview
                                file={{ url: val?.thumb }}
                                onClick={() => zoomImage(val)}
                                height={100}
                                width={"auto"}
                              />
                            ) : (
                              //   <ImagePreview
                              //     shot={{ ...val, ...selectedItem }}
                              //     size={100}
                              //     src={imageURL}
                              //     tags={val.tags}
                              //     fit="contain"
                              //     showMetaInfo={false}
                              //   />
                              <div></div>
                            )}
                          </div>
                        );
                      })}
                </Group>

                {!selectedItem ||
                (selectedItem && selectedItem.assets?.length === 0) ? (
                  <EmptyState
                    caption="There are no assets"
                    style={{ height: 150 }}
                  />
                ) : null}
                {/* <TalentList data={[{avatar:selectedItem.filePath,name:'Test User'}]}/> */}
              </Box>
            </Card>
          ) : (
            <Center sx={{ height: "100%", minHeight: 400 }}>
              <div style={{ textAlign: "center" }}>
                {/* <IconCamera size={48} stroke={1} /> */}
                <Title color={"dimmed"} order={3}>
                  Select a record
                </Title>
              </div>
            </Center>
          )}
        </ScrollArea>
      </div>

      <Modal
        opened={imageModalOpen}
        p={0}
        // title={selectedItem.name}
        trapFocus={true}
        closeOnEscape={true}
        id="captureModal"
        withCloseButton={false}
        fullScreen
        onClose={() => setImageModalOpen(false)}
        styles={{
          content: { padding: 0, height: "100vh" },
        }}
      >
        {/* <CaptureDetail
          showSettings={false}
          resoloveImage={false}
          image={selectedAsset}
          src={selectedAsset?.preview}
          onImageEvent={() => logger.log("On image event")}
          onCaptureChange={() => {}}
        /> */}

        <StyleAssetViewer
          user={user}
          style={selectedItem}
          index={selectedItem?.assets?.findIndex(
            (val) => val.assignedSequence === selectedAsset?.assignedSequence
          )}
          onClose={() => setImageModalOpen(false)}
        />
      </Modal>
    </Box>
  );
};

export default InfoPanel;

const BarcodeImage = () => {
  const { theme } = useStyles();
  const strokeColor =
    theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.brand[1];

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{
        fillRule: "evenodd",
        clipRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 1.5,
      }}
    >
      <path
        d="M891,293.385C891,273.304 874.696,257 854.615,257L169.385,257C149.304,257 133,273.304 133,293.385L133,730.615C133,750.696 149.304,767 169.385,767L854.615,767C874.696,767 891,750.696 891,730.615L891,293.385Z"
        style={{ fill: "none", stroke: strokeColor, strokeWidth: "15px" }}
      />
      <path
        d="M219.945,321.22L219.945,701.954"
        style={{
          fill: "none",
          stroke: strokeColor,
          strokeWidth: "38px",
          strokeLinecap: "butt",
        }}
      />
      <g transform="matrix(1,0,0,1,588.073,0)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "38px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,52.0052,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,84.0104,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,126.016,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,168.021,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,210.026,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,252.031,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "32.91px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,294.036,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,315.039,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,336.042,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,357.044,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,378.047,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,432.179,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,399.049,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,462.057,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,504.062,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "10.97px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(1,0,0,0.813459,536.068,59.9209)">
        <path
          d="M219.945,321.22L219.945,701.954"
          style={{
            fill: "none",
            stroke: strokeColor,
            strokeWidth: "21.94px",
            strokeLinecap: "butt",
          }}
        />
      </g>
      <g transform="matrix(2.17273,0,0,2.17273,-323.186,-775.261)">
        <text
          x="268.822px"
          y="664.032px"
          style={{
            fontFamily: "'AmsiPro-Bold', sans-serif",
            fontSize: "12px",
            fill: strokeColor,
          }}
        >
          NO SC
          <tspan x="303.958px " y="664.032px ">
            A
          </tspan>
          N A
          <tspan x="330.97px 337.654px " y="664.032px 664.032px ">
            VA
          </tspan>
          ILABLE
        </text>
      </g>
    </svg>
  );
};

const masterColumns = [
  {
    accessorKey: "targetId",
    header: "Target ID",
  },
  {
    accessorKey: "version",
    header: "Version",
  },
  {
    accessorKey: "productStatus",
    header: "Product Status",
  },
  {
    accessorKey: "styleNumber",
    header: "Style Number",
  },
  {
    accessorKey: "targetKeycode",
    header: "Target Keycode",
  },
  {
    accessorKey: "colour",
    header: "Colour",
  },
  {
    accessorKey: "brand",
    header: "Brand",
  },
  {
    accessorKey: "kmartKeycode",
    header: "Kmart Keycode",
  },
  {
    accessorKey: "variation",
    header: "Variation",
  },
  {
    accessorKey: "dept",
    header: "Department",
  },
  {
    accessorKey: "modified",
    header: "Modified",
  },
  {
    accessorKey: "variationSize",
    header: "Variation Size",
  },
  {
    accessorKey: "otb",
    header: "OTB",
  },
  {
    accessorKey: "productName",
    header: "Product Name",
  },
  {
    accessorKey: "apn",
    header: "APN",
  },
  {
    accessorKey: "targetSort",
    header: "Target Sort",
  },
];
